import React, { Dispatch } from "react";
import { ActionType } from "./types";
import { GetMaterialDto } from "../../services/Material/dto/get.dto";
import { UpdateStatusParams } from "./usecase.d";

export type MaterialStateType = {
  data: Array<GetMaterialDto>;
};

export type MaterialActionType = {
  type: symbol;
  items?: GetMaterialDto[];
  updatedItem?: GetMaterialDto;
  updatedItems?: GetMaterialDto[];
  updatedStatusItem?: UpdateStatusParams;
};

type MaterialReducerType = React.Reducer<MaterialStateType, MaterialActionType>;

export type MaterialDispatch = Dispatch<MaterialActionType>;

const initialGetState: MaterialStateType = {
  data: new Array<GetMaterialDto>(),
};

interface TransformUpdateStatusParams {
  originalData: Array<GetMaterialDto>;
  updatedData: UpdateStatusParams;
}

function transformUpdateStatusData({
  originalData,
  updatedData,
}: TransformUpdateStatusParams) {
  return originalData.map((item) => {
    const newItem = { ...item };
    if (item.materialKey === updatedData.materialKey) {
      newItem.isActive = updatedData.isActive;
      return newItem;
    }
    return newItem;
  });
}

interface TransformUpdateDataParams {
  originalData: Array<GetMaterialDto>;
  updatedData: GetMaterialDto;
}

function transformUpdateData({
  originalData,
  updatedData,
}: TransformUpdateDataParams) {
  return originalData.map((item) => {
    if (item.materialKey === updatedData.materialKey) {
      return updatedData;
    }
    return item;
  });
}

interface TransformUpdateListDataParams {
  originalData: Array<GetMaterialDto>;
  updatedDataList: GetMaterialDto[];
}

function transformUpdateDataList({
  originalData,
  updatedDataList,
}: TransformUpdateListDataParams) {
  return originalData.map((item) => {
    for (let index = 0; index < updatedDataList.length; index++) {
      const targetItem = updatedDataList[index];
      if (item.materialKey === targetItem.materialKey) {
        return targetItem;
      }
    }
    return item;
  });
}

export const Reducer: MaterialReducerType = (
  state = initialGetState,
  action,
) => {
  switch (action.type) {
    case ActionType.GetList:
      return {
        data: action.items || [],
      };
    case ActionType.Update:
      if (!action.updatedItem) {
        throw new Error("Updated item does not exists");
      }
      return {
        data: transformUpdateData({
          originalData: state.data,
          updatedData: action.updatedItem,
        }),
      };
    case ActionType.UpdateList:
      if (!action.updatedItems) {
        throw new Error("Updated item does not exists");
      }
      return {
        data: transformUpdateDataList({
          originalData: state.data,
          updatedDataList: action.updatedItems,
        }),
      };
    case ActionType.UpdateStatus:
      if (!action.updatedStatusItem) {
        throw new Error("Updated item does not exists");
      }
      return {
        data: transformUpdateStatusData({
          originalData: state.data,
          updatedData: action.updatedStatusItem,
        }),
      };
    default:
      return state;
  }
};
